import { Injectable } from '@angular/core';
import { StoreService } from './ngrx/store.service';
import { Subject } from 'rxjs';
import { MessageNotification } from './modules/models/messageNotification.type';


@Injectable({
  providedIn: 'root'
})
export class BroadcastService {
  private channel: BroadcastChannel;
  private documentDraftProcessedSubject = new Subject<MessageNotification>();
  documentDraftProcessed$ = this.documentDraftProcessedSubject.asObservable();
  
  private documentDraftProgressSubject = new Subject<MessageNotification>();
  documentDraftProgress$ = this.documentDraftProgressSubject.asObservable();
  
  private sicaNotificationSubject = new Subject<MessageNotification>();
  sicaNotification$ = this.sicaNotificationSubject.asObservable();

  constructor(private storeService:StoreService) {
    this.channel = new BroadcastChannel('ngrx_channel');

    // Listen for messages from other tabs
    this.channel.onmessage = (event) => {
      if (event.data.type === 'STATE_UPDATE' && event.data.state) {
        this.storeService.setCurrentCompany(event.data.state.company);
        this.storeService.setUserPartner(event.data.state.partner);
        this.storeService.setIsPartnerAdmin(event.data.state.isAdmin);
        this.storeService.setIsMandataire(event.data.state.isMandataire);
        this.storeService.setUserCustomer(event.data.state.customer);
      }
      else {
        this.sendState();
      }
    };

  }

  // Request state from an existing tab when a new tab is opened
  requestState() {
    this.channel.postMessage({ type: 'REQUEST_STATE' });
  }

  emitDocumentDraftProcessed(notification: MessageNotification): void {
    this.documentDraftProcessedSubject.next(notification);
  }

  emitDocumentDraftProgress(notification: MessageNotification): void {
    this.documentDraftProgressSubject.next(notification);
  }

  emitSicaNotification(notification: MessageNotification): void {
    this.sicaNotificationSubject.next(notification);
  }

  private sendState() {
    this.channel.postMessage({ type: 'STATE_UPDATE', state: {company:this.storeService.getCurrentCompany()
                                                              ,partner:this.storeService.getUserPartner(),
                                                              isAdmin:this.storeService.IsPartnerAdmin(),
                                                              customer:this.storeService.getUserCustomer()}
    });

  }

}
